import { render, staticRenderFns } from "./DevLibsWizard.vue?vue&type=template&id=3815475f"
import script from "./DevLibsWizard.vue?vue&type=script&lang=js"
export * from "./DevLibsWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports